// Middleware to keep state up to date between tabs by syncing actions using BroadcastChannel
import { BroadcastChannel } from 'broadcast-channel'

const channel = new BroadcastChannel('plickers-tab-sync-bc')

export function getTabSyncBCMiddleware() {
  return () => (next) => (action) => {
    if (action && action.syncActionBC === true) {
      channel.postMessage({
        action,
      })
    }
    next(action)
  }
}

export function setupTabSyncBC(store) {
  channel.onmessage = (event) => {
    store.dispatch({ ...event.action, syncActionBC: false })
  }
}
